import React, { useState, useRef, useEffect } from "react";
import style from "./CustomSelect.module.css";

const CustomSelect = ({ options, onSelect, selectedIndex }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(options[selectedIndex]);
  const selectRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  useEffect(() => {
    setSelected(options[selectedIndex]);
  }, [selectedIndex, options]);

  const handleSelect = (option, index) => {
    setSelected(option);
    setIsOpen(false);
    onSelect(index);
  };

  // 외부 클릭 시 드롭다운 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={selectRef} className={style.selectContainer}>
      <div className={style.selectHeader} onClick={toggleDropdown}>
        <span>{selected}</span>
        <span className={style.arrow}>{isOpen ? "▲" : "▼"}</span>
      </div>
      {isOpen && (
        <ul className={style.selectList}>
          {options.map((option, index) => (
            <li
              key={index}
              className={style.selectItem}
              onClick={() => handleSelect(option, index)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
